import { Play, Pause } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useGetSettingsQuery, useStartBotMutation } from "@/store/api";
import { useAppSelector } from "@/store";
import { toast } from "sonner";

/**
 * Full-width banner shown above the route outlet whenever the master
 * `paused` flag is on. Admin-only: /api/settings 403s for regular users,
 * so we skip the query entirely for them and render nothing (fail silent).
 */
export function PausedBanner() {
  const isAdmin = useAppSelector((s) => s.auth.user?.role === "admin");
  const settings = useGetSettingsQuery(undefined, {
    skip: !isAdmin,
    pollingInterval: 30000,
  });
  const [startBot, { isLoading: resuming }] = useStartBotMutation();

  const paused = settings.data?.paused === true;
  if (!isAdmin || !paused) return null;

  const onResume = async () => {
    if (!confirm("Resume trading? Engine entries will start executing again.")) return;
    try {
      await startBot().unwrap();
      toast.success("Trading resumed");
    } catch {
      toast.error("Resume failed");
    }
  };

  return (
    <div className="shrink-0 border-b border-warn/40 bg-warn/15 text-warn px-4 py-2 flex items-center gap-3 flex-wrap">
      <Pause className="w-4 h-4 shrink-0" />
      <span className="text-sm font-medium">
        Trading is PAUSED — all engine entries are blocked. Exits continue to run.
      </span>
      <Button
        variant="primary"
        size="sm"
        className="ml-auto"
        onClick={onResume}
        disabled={resuming}
      >
        <Play className="w-4 h-4" />
        {resuming ? "Resuming…" : "Resume trading"}
      </Button>
    </div>
  );
}
